export enum HttpStatusCode {
    NotFound = 404,
    Unauthorized = 401
}

export type ErrorResponse = {
    errors: {
        key: string
        message: string
    }[]
}
